import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  RxLpComHowBonusIsCalculatedDataBody,
  RxLpComHowBonusIsCalculatedDataHead,
} from './RxLpComHowBonusIsCalculatedData'

import styles from './HowBonusIsCalculated.module.css'

export const RxLpComHowBonusIsCalculatedCalculations: FC = () => {
  return (
    <div className="flex flex-col gap-1 rounded-m bg-light-primary-low">
      <div className="p-6">
        <p className="text-m font-medium">
          <FormattedMessage id="rx.com.bonus.table.title" />
        </p>
      </div>

      <div className="tablet:px-6">
        <table className={clsx(styles['rounded-table'], 'table-auto text-xs')}>
          <thead className="bg-light-brand-medium">
            <tr className="text-center font-medium">
              {RxLpComHowBonusIsCalculatedDataHead.map((head) => (
                <th className="px-3 py-2" key={head.key} scope="col">
                  {head.heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-light-brand-low">
            {RxLpComHowBonusIsCalculatedDataBody.map((data, index) => {
              const rowClass = clsx(
                index < RxLpComHowBonusIsCalculatedDataBody.length - 1 &&
                  'border-b border-dark-primary-min',
              )

              return (
                <tr className={rowClass} key={data.key}>
                  <td className="px-4 py-3">{data.medication}</td>
                  <td className="px-4 py-3">
                    <div className="flex justify-center">
                      <div className="w-fit rounded-m bg-light-tertiary p-2">
                        {data.perscriptionBonus}
                      </div>
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex justify-center">
                      <div className="w-fit rounded-m bg-light-tertiary p-2">
                        {data.totalBonus}
                      </div>
                    </div>
                  </td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>

      <div className="flex items-center gap-4 p-3 tablet:px-6 tablet:pb-6 tablet:pt-4">
        <span
          // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
          className="max-w-[21rem] text-s leading-none tablet:w-full"
        >
          <FormattedMessage id="rx.com.bonus.saving.description" />
        </span>
        <span className="min-w-fit text-2xl font-medium italic text-dark-brand">
          <FormattedMessage id="rx.com.bonus.saving.value" />
        </span>
      </div>
    </div>
  )
}
